export const ingColors = {
  primary: '#FF6200',
};
